var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBin2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 16.34,
    height: 18,
    viewBox: "0 0 16.34 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1012",
    "data-name": "Rectangle 1012",
    width: 16.34,
    height: 18,
    fill: "#a5a5a5"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Bin",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2723",
    "data-name": "Group 2723",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2064",
    "data-name": "Path 2064",
    d: "M15.636,3.318H12.193V2.365A2.367,2.367,0,0,0,9.829,0H6.512A2.367,2.367,0,0,0,4.147,2.365v.953H.705a.705.705,0,0,0,0,1.411h.954V15.637A2.367,2.367,0,0,0,4.023,18h8.295a2.367,2.367,0,0,0,2.363-2.364V4.729h.955a.705.705,0,0,0,0-1.411M5.557,2.365a.955.955,0,0,1,.955-.954H9.829a.955.955,0,0,1,.954.954v.953H5.557Zm7.715,13.272a.956.956,0,0,1-.954.954H4.023a.956.956,0,0,1-.955-.954V4.729h10.2Z",
    transform: "translate(0 0)",
    fill: "#a5a5a5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2065",
    "data-name": "Path 2065",
    d: "M7.705,9A.705.705,0,0,0,7,9.705v4.978a.705.705,0,0,0,1.41,0V9.705A.705.705,0,0,0,7.705,9",
    transform: "translate(-1.194 -1.535)",
    fill: "#a5a5a5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2066",
    "data-name": "Path 2066",
    d: "M11.705,9A.705.705,0,0,0,11,9.705v4.978a.705.705,0,0,0,1.41,0V9.705A.705.705,0,0,0,11.705,9",
    transform: "translate(-1.876 -1.535)",
    fill: "#a5a5a5"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBin2);
export default __webpack_public_path__ + "static/media/Bin2.959a9ee8d18c66d1af3d8f68699da4fc.svg";
export { ForwardRef as ReactComponent };